/* globalmodule */
define('../src/sublayouts/m66-preloader/m66-preloader',['jquery', 'numeral'], function($) {

    'use strict';

    var m66Preloader = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialise component
     */

    m66Preloader.prototype.init = function() {
        this.rate = 0;

        var _this = this;

        $(window).off('m66Tick').on('m66Tick', function() {
            _this.load();
        })
    };

    m66Preloader.prototype.load = function() {
        var _this = this,
            base = parseInt(this.$component.attr('data-base')),
            percentage = parseInt(this.$component.attr('data-per')),
            $placeholder = this.$component.find('.m66-preloader-per_rate'),
            current = parseInt($placeholder.html()),
            $bar = this.$component.find('.m66-preloader-per_green'),
            tick;

        if (((percentage / base) * 100) <= 100) {
            $bar.css('width', ((percentage / base) * 100).toString() + '%');

            tick = (((percentage / base) * 100) - _this.rate) / 75;

            for (var i = 0; i < 75; i++) {
                setTimeout(function() {
                    $placeholder.html(numeral(_this.rate + tick).format('00.'));
                    _this.rate = _this.rate + tick;
                }, (500 / 75) * i);
            };
        } else {
            $bar.css('width', (100).toString() + '%');

            tick = ((100) - _this.rate) / 75;

            for (var i = 0; i < 75; i++) {
                setTimeout(function() {
                    $placeholder.html(numeral(_this.rate + tick).format('00.'));
                    _this.rate = _this.rate + tick;
                }, (500 / 75) * i);
            };
        };

    };

    return m66Preloader;
});

